import React from 'react';
import CarIcon from './car-icon';
import AnimatedCircle from './animated-circle';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100px;
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  & > svg:first-child {
    position: absolute;
    top: 25%;
    left: 25%;
    width: 22%;
    height: 22%;
  }

  & > svg:last-child {
    position: absolute;
    inset: 0;
    width: 70%;
    height: 70%;
  }
`;

const LoadingIcon = () => {
  return (
    <Wrapper>
      <CarIcon />
      <AnimatedCircle />
    </Wrapper>
  );
};

export default LoadingIcon;
